module.exports = __webpack_public_path__ + "static/travizano-3cb4de64dc551a5ec86069e0fe708b23.jpg";